import React from 'react';
import clsx from 'clsx';
import { Accordion } from 'semantic-ui-react';

const AccordionWrapper = ({
  children,
  className,
  fluid,
  open,
  scrolling,
  styled,
}) => (
  <Accordion
    fluid={fluid}
    styled={styled}
    className={clsx('aridhia-accordion-wrapper', className, scrolling && 'scrolling', open && 'h-100p')}
  >
    {children}
  </Accordion>
);

export default AccordionWrapper;
